import CreditUsageClient from '@/client/mentor/CreditUsageClient'
import type {Maybe} from '@/types'
import {assertNonNil} from '@/utils/assert'
import {isNullOrUndefined} from '@/utils/utils'
import {useQuery} from '@tanstack/vue-query'
import {computed, toValue, type MaybeRef} from 'vue'

export function useAssistantCreditUsage(
  companyId: MaybeRef<Maybe<number>>,
  options?: {
    enabled?: MaybeRef<boolean>
  }
) {
  const resolvedCompanyId = computed(() => toValue(companyId))
  const hasCompanyId = computed(() => !isNullOrUndefined(resolvedCompanyId.value))

  const queryKey = computed(() => ['mentor', 'credit-usage', resolvedCompanyId.value])

  const isEnabledByCaller = computed(() => toValue(options?.enabled) ?? true)
  const queryEnabled = computed(() => hasCompanyId.value && isEnabledByCaller.value)

  const creditUsageQuery = useQuery({
    queryKey,
    enabled: queryEnabled,
    queryFn: async () => await CreditUsageClient.getCreditUsage(assertNonNil(resolvedCompanyId.value)),
    staleTime: 60 * 1_000,
    refetchInterval: 60 * 1_000,
  })

  async function updateCreditUsage() {
    await creditUsageQuery.refetch()
  }

  return {
    creditUsage: creditUsageQuery.data,
    updateCreditUsage,
  }
}
